// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__LprQY","name":"Header_name__2T3bb","birthday":"Header_birthday__1JCdp","skeleton":"Header_skeleton__g23DQ"};